// Mismo reparto de golpes que el servidor (server/utils/handicap.js),
// para poder mostrar el par de cada jugador sin esperar al backend.

export const HANDICAP_MAX = 54;

// Handicap de juego: el handicap exacto redondeado al entero más próximo.
export function handicapDeJuego(handicapExacto) {
  const handicap = Number(handicapExacto);
  if (!Number.isFinite(handicap)) return 0;
  return Math.min(Math.max(Math.round(handicap), 0), HANDICAP_MAX);
}

// Golpes de ventaja que recibe un hoyo según su índice de handicap.
export function ventajaEnHoyo(handicapJuego, indiceHoyo) {
  const base = Math.floor(handicapJuego / 18);
  const extra = indiceHoyo <= handicapJuego % 18 ? 1 : 0;
  return base + extra;
}

// Par personal = par del campo + handicap de juego.
export function parPersonal(parCampo, handicapExacto) {
  return parCampo + handicapDeJuego(handicapExacto);
}

export function parDelCampo(hoyos) {
  return (hoyos || []).reduce((total, hoyo) => total + Number(hoyo.par || 0), 0);
}

// Formatea una diferencia sobre el par: -2, E, +5
export function formatVsPar(valor) {
  if (valor === null || valor === undefined) return '—';
  if (valor === 0) return 'E';
  return valor > 0 ? `+${valor}` : `${valor}`;
}

// Nombre del resultado de un hoyo respecto al par del jugador. Si el hoyo le da
// golpes de ventaja el resultado es neto ("Birdie neto"), no bruto.
export function nombreResultado(golpes, parJugador, conVentaja = false) {
  if (!golpes) return '';
  if (golpes === 1) return 'Hoyo en uno';

  const diferencia = golpes - parJugador;
  let nombre;
  if (diferencia <= -3) nombre = 'Albatros';
  else if (diferencia === -2) nombre = 'Eagle';
  else if (diferencia === -1) nombre = 'Birdie';
  else if (diferencia === 0) nombre = 'Par';
  else if (diferencia === 1) nombre = 'Bogey';
  else if (diferencia === 2) nombre = 'Doble bogey';
  else return `+${diferencia}`;

  return conVentaja ? `${nombre} neto` : nombre;
}
